"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiPopover = void 0;
var breakpoints_1 = require("../../global/breakpoints");
var palette_1 = require("../../global/palette");
var shadows_1 = require("../../global/shadows");
var typography_1 = require("../../global/typography");
exports.MuiPopover = {
    paper: (_a = {
            color: palette_1.palette.grey[800],
            boxShadow: shadows_1.boxShadow.large,
            maxWidth: 400,
            maxHeight: 400,
            padding: '20px 24px',
            '& p': __assign({}, typography_1.typography.body2)
        },
        _a[breakpoints_1.breakpoints.down('xs')] = {
            width: 'calc(100% - 32px)',
        },
        _a),
    root: {
        '&[variant="inline"]': {
            '& .MuiPopover-paper': (_b = {
                    boxShadow: '0px 10px 15px rgba(25, 34, 40, 0.05), 0px 2px 6px rgba(25, 34, 40, 0.05)',
                    maxWidth: '48ch',
                    width: '100%',
                    '& .MuiPickersBasePicker-container': {
                        alignItems: 'center',
                        justifyContent: 'center',
                    }
                },
                _b[breakpoints_1.breakpoints.down('xs')] = {
                    width: 'calc(100% - 32px)',
                },
                _b),
        },
    },
};
